import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FiltersComponent } from './components/filters/filters.component';
import { FilterChipsComponent } from './components/filter-chips/filter-chips.component';
import { MyListService } from 'src/app/shared/services/my-list.service';
import { CommonService } from './services/common.service';
import { J4uLogoContainerComponent } from './components/j4u-logo-container/j4u-logo-container.component';
import { ContinuityOfferService } from './services/continuity-offer.service';
import { ContinuityOfferComponent } from './components/continuity-offer/continuity-offer.component';
import { CoreModule } from 'abs-ngx-library/src/lib/core';
import { SortComponent } from './components/sort/sort.component';
import { B4UService } from './services/b4u.service';
import { TokenUserInfo } from './services/tokenUserInfo.service';
import { GridService } from './services/grid.service';
import { DomSanitizerPipe } from './pipes/dom-sanitizer.pipe';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BannerUnitComponent } from './components/banner-unit/banner-unit.component';
import { GoogleAdManagerService } from './services/google-ad-manager.service';
import { LaunchpadService } from './services/launchpad.service';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { SponsoredCarouselWrapperComponent } from './components/sponsored-carousel-wrapper/sponsored-carousel-wrapper.component';
import { RightDrawerModule } from 'abs-ngx-library/src/lib/right-drawer';
import { OfferQualifiedProductsModule } from 'abs-ngx-library/src/lib/offer-qualified-products';
import { CouponListModule } from 'abs-ngx-library/src/lib/coupon-list';
import { LogService } from './services/log.service';
import { DiscoveryService } from './services/discovery.service';
import { HtoAllocationService } from './services/hto-allocation.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ActionableItemComponent } from './components/actionable-item/actionable-item.component';
import {SavingsUpsellComponent} from './components/savings-upsell/savings-upsell.component';
import { JoinFreeCtaComponent } from './components/zone-component/membership-benefits/join-free-cta.component';
import { TryFreshpassComponent } from './components/zone-component/membership-benefits/try-freshpass.component';
import { MembershipBenefitsErrorComponent } from './components/membership-benefits-error/membership-benefits-error.component';
import { ZoneComponent } from './components/zone/zone.component';

@NgModule({
  declarations: [
    FiltersComponent,
    FilterChipsComponent,
    J4uLogoContainerComponent,
    ContinuityOfferComponent,
    SortComponent,
    DomSanitizerPipe,
    BreadcrumbComponent,
    ActionableItemComponent,
    BannerUnitComponent,
    SponsoredCarouselWrapperComponent,
    SavingsUpsellComponent,
    JoinFreeCtaComponent,
    TryFreshpassComponent,
    MembershipBenefitsErrorComponent,
    ZoneComponent
  ],
  imports: [
    CommonModule,
    CoreModule.forRoot({appName: null, programType: 'abs'}),
    CollapseModule,
    [ProgressbarModule.forRoot()],
    RightDrawerModule,
    OfferQualifiedProductsModule,
    CouponListModule,
    BsDropdownModule
  ],
  providers: [
    CommonService,
    MyListService,
    ContinuityOfferService,
    B4UService,
    TokenUserInfo,
    GridService,
    GoogleAdManagerService,
    LaunchpadService,
    LogService,
    DiscoveryService,
    HtoAllocationService
  ],
  exports: [
    FiltersComponent,
    FilterChipsComponent,
    J4uLogoContainerComponent,
    ContinuityOfferComponent,
    SortComponent,
    DomSanitizerPipe,
    BreadcrumbComponent,
    BannerUnitComponent,
    SponsoredCarouselWrapperComponent,
    ActionableItemComponent,
    SavingsUpsellComponent,
    MembershipBenefitsErrorComponent,
    ZoneComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
